export default "__VITE_ASSET__DUYzD0Ih__"